module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mbnskms9-536e5ebebe3c25ffa31dac261b8be585.jpg";